// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file shift_plan_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DriverOnShift, DriverOnShiftJson } from "./driver_on_shift_pb";
import { file_driver_on_shift } from "./driver_on_shift_pb";
import type { ShiftCellState, ShiftCellStateJson, ShiftPlanType, ShiftPlanTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { ListFilter, ListFilterJson, ListInfo, ListInfoJson, MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { ShiftPlanCreateSchema, ShiftPlanSchema } from "./shift_plan_pb";
import { file_shift_plan } from "./shift_plan_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file shift_plan_service.proto.
 */
export const file_shift_plan_service: GenFile = /*@__PURE__*/
  fileDesc("ChhzaGlmdF9wbGFuX3NlcnZpY2UucHJvdG8SCXJhY2Nvb25haSJaChZTaGlmdFBsYW5EZWxldGVSZXF1ZXN0EgoKAmlkGAEgAigEEjQKFW93bmVyX29yZ2FuaXphdGlvbl9pZBgCIAIoBFIVb3duZXJfb3JnYW5pemF0aW9uX2lkItoBChRTaGlmdFNjaGVkdWxlUmVxdWVzdBI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYASACKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZBIMCgR5ZWFyGAIgAigNEg0KBW1vbnRoGAMgAigNEjcKC2xpc3RfZmlsdGVyGAogASgLMhUucmFjY29vbmFpLkxpc3RGaWx0ZXJSC2xpc3RfZmlsdGVyEjYKFm93bmVyX29yZ2FuaXphdGlvbl9pZHMYCyADKARSFm93bmVyX29yZ2FuaXphdGlvbl9pZHMinwIKEVNoaWZ0U2NoZWR1bGVDZWxsEgwKBGRhdGUYASACKAkSKAoFc3RhdGUYAiACKA4yGS5yYWNjb29uYWkuU2hpZnRDZWxsU3RhdGUSLgoSZHJpdmVyX29uX3NoaWZ0X2lkGAMgASgEUhJkcml2ZXJfb25fc2hpZnRfaWQSJAoNc2hpZnRfcGxhbl9pZBgEIAEoBFINc2hpZnRfcGxhbl9pZBI2CglwbGFuX3R5cGUYBiABKA4yGC5yYWNjb29uYWkuU2hpZnRQbGFuVHlwZVIJcGxhbl90eXBlEkQKEGRyaXZlcl9vbl9zaGlmdHMYBSADKAsyGC5yYWNjb29uYWkuRHJpdmVyT25TaGlmdFIQZHJpdmVyX29uX3NoaWZ0cyKnAQoWRHJpdmVyU2hpZnRTY2hlZHVsZVJvdxIcCglkcml2ZXJfaWQYASACKARSCWRyaXZlcl9pZBIgCgtkcml2ZXJfbmFtZRgCIAIoCVILZHJpdmVyX25hbWUSKwoFY2VsbHMYAyADKAsyHC5yYWNjb29uYWkuU2hpZnRTY2hlZHVsZUNlbGwSIAoLbW9udGhfdG90YWwYBCACKA1SC21vbnRoX3RvdGFsIoIBCg1TaGlmdFNjaGVkdWxlEg0KBXRvZGF5GAEgAigJEi8KBHJvd3MYAiADKAsyIS5yYWNjb29uYWkuRHJpdmVyU2hpZnRTY2hlZHVsZVJvdxIxCglsaXN0X2luZm8YAyABKAsyEy5yYWNjb29uYWkuTGlzdEluZm9SCWxpc3RfaW5mbzL/AQoQU2hpZnRQbGFuU2VydmljZRJQChFMaXN0U2hpZnRTY2hlZHVsZRIfLnJhY2Nvb25haS5TaGlmdFNjaGVkdWxlUmVxdWVzdBoYLnJhY2Nvb25haS5TaGlmdFNjaGVkdWxlIgASRQoPQ3JlYXRlU2hpZnRQbGFuEhoucmFjY29vbmFpLlNoaWZ0UGxhbkNyZWF0ZRoULnJhY2Nvb25haS5TaGlmdFBsYW4iABJSCg9EZWxldGVTaGlmdFBsYW4SIS5yYWNjb29uYWkuU2hpZnRQbGFuRGVsZXRlUmVxdWVzdBoaLnJhY2Nvb25haS5NZXNzYWdlUmVzcG9uc2UiAEIGWgQuL3Bi", [file_driver_on_shift, file_enums, file_general, file_shift_plan]);

/**
 * @generated from message raccoonai.ShiftPlanDeleteRequest
 */
export type ShiftPlanDeleteRequest = Message<"raccoonai.ShiftPlanDeleteRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.ShiftPlanDeleteRequest
 */
export type ShiftPlanDeleteRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.ShiftPlanDeleteRequest.
 * Use `create(ShiftPlanDeleteRequestSchema)` to create a new message.
 */
export const ShiftPlanDeleteRequestSchema: GenMessage<ShiftPlanDeleteRequest, {jsonType: ShiftPlanDeleteRequestJson}> = /*@__PURE__*/
  messageDesc(file_shift_plan_service, 0);

/**
 * @generated from message raccoonai.ShiftScheduleRequest
 */
export type ShiftScheduleRequest = Message<"raccoonai.ShiftScheduleRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required uint32 year = 2;
   */
  year: number;

  /**
   * 1-12
   *
   * @generated from field: required uint32 month = 3;
   */
  month: number;

  /**
   * Paginates DRIVERS (schedule rows), never cells: a page always holds complete rows.
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;

  /**
   * Organizations to aggregate over, each checked; owner_organization_id is added to them.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 11 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];
};

/**
 * @generated from message raccoonai.ShiftScheduleRequest
 */
export type ShiftScheduleRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required uint32 year = 2;
   */
  year?: number;

  /**
   * 1-12
   *
   * @generated from field: required uint32 month = 3;
   */
  month?: number;

  /**
   * Paginates DRIVERS (schedule rows), never cells: a page always holds complete rows.
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;

  /**
   * Organizations to aggregate over, each checked; owner_organization_id is added to them.
   *
   * @generated from field: repeated uint64 owner_organization_ids = 11 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];
};

/**
 * Describes the message raccoonai.ShiftScheduleRequest.
 * Use `create(ShiftScheduleRequestSchema)` to create a new message.
 */
export const ShiftScheduleRequestSchema: GenMessage<ShiftScheduleRequest, {jsonType: ShiftScheduleRequestJson}> = /*@__PURE__*/
  messageDesc(file_shift_plan_service, 1);

/**
 * @generated from message raccoonai.ShiftScheduleCell
 */
export type ShiftScheduleCell = Message<"raccoonai.ShiftScheduleCell"> & {
  /**
   * "YYYY-MM-DD", Asia/Almaty calendar day
   *
   * @generated from field: required string date = 1;
   */
  date: string;

  /**
   * @generated from field: required raccoonai.ShiftCellState state = 2;
   */
  state: ShiftCellState;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 3 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: optional uint64 shift_plan_id = 4 [json_name = "shift_plan_id"];
   */
  shiftPlanId: bigint;

  /**
   * Set on cells that come from a plan; absent on driver_on_shift-only cells.
   *
   * @generated from field: optional raccoonai.ShiftPlanType plan_type = 6 [json_name = "plan_type"];
   */
  planType: ShiftPlanType;

  /**
   * Every shift the driver had that day (truck preloaded), for the cell
   * popover: plate number, truck model/type, raw status, tw window and
   * completion time. A driver can work more than one shift in a day, so this
   * repeats; the first entry is the one that paints the cell (see
   * driver_on_shift_id). Plan-only cells (PLANNED and plan-derived MISSED)
   * carry no shifts.
   *
   * @generated from field: repeated raccoonai.DriverOnShift driver_on_shifts = 5 [json_name = "driver_on_shifts"];
   */
  driverOnShifts: DriverOnShift[];
};

/**
 * @generated from message raccoonai.ShiftScheduleCell
 */
export type ShiftScheduleCellJson = {
  /**
   * "YYYY-MM-DD", Asia/Almaty calendar day
   *
   * @generated from field: required string date = 1;
   */
  date?: string;

  /**
   * @generated from field: required raccoonai.ShiftCellState state = 2;
   */
  state?: ShiftCellStateJson;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 3 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: optional uint64 shift_plan_id = 4 [json_name = "shift_plan_id"];
   */
  shift_plan_id?: string;

  /**
   * Set on cells that come from a plan; absent on driver_on_shift-only cells.
   *
   * @generated from field: optional raccoonai.ShiftPlanType plan_type = 6 [json_name = "plan_type"];
   */
  plan_type?: ShiftPlanTypeJson;

  /**
   * Every shift the driver had that day (truck preloaded), for the cell
   * popover: plate number, truck model/type, raw status, tw window and
   * completion time. A driver can work more than one shift in a day, so this
   * repeats; the first entry is the one that paints the cell (see
   * driver_on_shift_id). Plan-only cells (PLANNED and plan-derived MISSED)
   * carry no shifts.
   *
   * @generated from field: repeated raccoonai.DriverOnShift driver_on_shifts = 5 [json_name = "driver_on_shifts"];
   */
  driver_on_shifts?: DriverOnShiftJson[];
};

/**
 * Describes the message raccoonai.ShiftScheduleCell.
 * Use `create(ShiftScheduleCellSchema)` to create a new message.
 */
export const ShiftScheduleCellSchema: GenMessage<ShiftScheduleCell, {jsonType: ShiftScheduleCellJson}> = /*@__PURE__*/
  messageDesc(file_shift_plan_service, 2);

/**
 * @generated from message raccoonai.DriverShiftScheduleRow
 */
export type DriverShiftScheduleRow = Message<"raccoonai.DriverShiftScheduleRow"> & {
  /**
   * @generated from field: required uint64 driver_id = 1 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: required string driver_name = 2 [json_name = "driver_name"];
   */
  driverName: string;

  /**
   * Sparse: only days that have a shift or a plan; missing days render empty.
   *
   * @generated from field: repeated raccoonai.ShiftScheduleCell cells = 3;
   */
  cells: ShiftScheduleCell[];

  /**
   * Shifts plus day and night plans; planned days off are excluded.
   *
   * @generated from field: required uint32 month_total = 4 [json_name = "month_total"];
   */
  monthTotal: number;
};

/**
 * @generated from message raccoonai.DriverShiftScheduleRow
 */
export type DriverShiftScheduleRowJson = {
  /**
   * @generated from field: required uint64 driver_id = 1 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: required string driver_name = 2 [json_name = "driver_name"];
   */
  driver_name?: string;

  /**
   * Sparse: only days that have a shift or a plan; missing days render empty.
   *
   * @generated from field: repeated raccoonai.ShiftScheduleCell cells = 3;
   */
  cells?: ShiftScheduleCellJson[];

  /**
   * Shifts plus day and night plans; planned days off are excluded.
   *
   * @generated from field: required uint32 month_total = 4 [json_name = "month_total"];
   */
  month_total?: number;
};

/**
 * Describes the message raccoonai.DriverShiftScheduleRow.
 * Use `create(DriverShiftScheduleRowSchema)` to create a new message.
 */
export const DriverShiftScheduleRowSchema: GenMessage<DriverShiftScheduleRow, {jsonType: DriverShiftScheduleRowJson}> = /*@__PURE__*/
  messageDesc(file_shift_plan_service, 3);

/**
 * @generated from message raccoonai.ShiftSchedule
 */
export type ShiftSchedule = Message<"raccoonai.ShiftSchedule"> & {
  /**
   * Server-computed Asia/Almaty "today"; clients must use it instead of the browser
   * clock so cell states and editability agree with the backend.
   *
   * @generated from field: required string today = 1;
   */
  today: string;

  /**
   * @generated from field: repeated raccoonai.DriverShiftScheduleRow rows = 2;
   */
  rows: DriverShiftScheduleRow[];

  /**
   * total_items counts the organization's drivers (rows), not cells.
   *
   * @generated from field: optional raccoonai.ListInfo list_info = 3 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.ShiftSchedule
 */
export type ShiftScheduleJson = {
  /**
   * Server-computed Asia/Almaty "today"; clients must use it instead of the browser
   * clock so cell states and editability agree with the backend.
   *
   * @generated from field: required string today = 1;
   */
  today?: string;

  /**
   * @generated from field: repeated raccoonai.DriverShiftScheduleRow rows = 2;
   */
  rows?: DriverShiftScheduleRowJson[];

  /**
   * total_items counts the organization's drivers (rows), not cells.
   *
   * @generated from field: optional raccoonai.ListInfo list_info = 3 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.ShiftSchedule.
 * Use `create(ShiftScheduleSchema)` to create a new message.
 */
export const ShiftScheduleSchema: GenMessage<ShiftSchedule, {jsonType: ShiftScheduleJson}> = /*@__PURE__*/
  messageDesc(file_shift_plan_service, 4);

/**
 * @generated from service raccoonai.ShiftPlanService
 */
export const ShiftPlanService: GenService<{
  /**
   * @generated from rpc raccoonai.ShiftPlanService.ListShiftSchedule
   */
  listShiftSchedule: {
    methodKind: "unary";
    input: typeof ShiftScheduleRequestSchema;
    output: typeof ShiftScheduleSchema;
  },
  /**
   * @generated from rpc raccoonai.ShiftPlanService.CreateShiftPlan
   */
  createShiftPlan: {
    methodKind: "unary";
    input: typeof ShiftPlanCreateSchema;
    output: typeof ShiftPlanSchema;
  },
  /**
   * @generated from rpc raccoonai.ShiftPlanService.DeleteShiftPlan
   */
  deleteShiftPlan: {
    methodKind: "unary";
    input: typeof ShiftPlanDeleteRequestSchema;
    output: typeof MessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_shift_plan_service, 0);

